/**
 * Api
 *  Service to handle API calls through axios...
 *
 * @author     K. van den Broek <k.vandenbroek@uselab.com>
 * @copyright  Uselab Amsterdam
 *
 */

import axios from 'axios'
import config from './config';

const STORAGE = config.get('GLOBAL.LOCAL_STORAGE');
export const AUTH_STORAGE = `${STORAGE}/auth`

export default () => {
  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }

  const api = axios.create({
    baseURL: config.get('GLOBAL.API_URL'),
    headers
  });

  const httpInterceptor = (response) => {
    return response;
  }

  const errorInterceptor = (error) => {
    const response = typeof error.response === 'object' ? error.response : {};
    return Promise.reject(response);
  }

  const authorizationRequestInterceptor = (config) => {
    const apiToken = localStorage.getItem(AUTH_STORAGE);
    if (apiToken) {
      config.headers.Authorization = `Bearer ${apiToken}`;
    }
    return config;
  }

  api.interceptors.request.use(authorizationRequestInterceptor);
  api.interceptors.response.use(httpInterceptor, errorInterceptor);

  return api;
};
